import url_read from "workflow/utils/url_read"
import get_content_type_for_response from "workflow/requests/get_content_type_for_response"
import get_content_length_for_response from "workflow/requests/get_content_length_for_response"
import get_filename_for_response from "workflow/requests/get_filename_for_response"
import partial from "rfuncs/functions/partial"

export const process_response = (suggested_type, suggested_name, xhttp) => ({
    status: xhttp.status,
    bytes: new Uint8Array(xhttp.response),
    name: suggested_name || get_filename_for_response(xhttp),
    content_type: suggested_type || get_content_type_for_response(xhttp),
    content_length: get_content_length_for_response(xhttp)
})
export default (
    url,
    progress,
    props = {},
    suggested_type = null,
    suggested_name = null
) =>
    url_read(url, {
        with_credentials: false,
        response_type: "arraybuffer",
        progress,
        ...props
    }).then(partial(process_response, suggested_type, suggested_name))
